import { toast } from "react-toastify";
import { CustomToast } from "../commons/Button/customToast";

const defaultOptions = {
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  position: "top-right",
  icon: false, 
};

export const showSuccessToast = (message) => {
  toast.success(<CustomToast message={message} type="success" />, defaultOptions);
};

export const showErrorToast = (message) => {
  toast.error(<CustomToast message={message} type="error" />, defaultOptions);
};

export const showInfoToast = (message) => {
  toast.info(<CustomToast message={message} type="info" />, defaultOptions);
};

export const showWarningToast = (message) => {
  toast.warn(<CustomToast message={message} type="warning" />, defaultOptions);
};